// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","intro":"Ibeq6","introText":"_1ZN88","cta":"_1lgUP","label":"RrrCN","imgIntro":"w3J80"};